import React from 'react'
import Img1 from '../../assets/img/blog/blog6.png'
import recentImg from '../../assets/img/recent1.png'
import featureImg2 from '../../assets/img/blog/feature2.jpeg'
import blog1 from '../../assets/img/blog/blog1.jpeg'
import { SearchNormal1, ArrowLeft, ArrowRight } from 'iconsax-react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import CTAButton from '../../components/CTA/CTAButton'
import { Link } from 'react-router-dom'
import { Helmet } from "react-helmet-async";

function BLogDetails() {
    const BlogDetails = [
        {
            id: 1,
            title: 'Blog Title',
            date: '2022-10-10',
        }
    ];
    const RecentStories = [
        {
            id: 1,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        },
        {
            id: 2,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        },
        {
            id: 3,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        },
        {
            id: 4,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        }
    ];

    const recentblog = [
        {
            id: 1,
            title: 'Recent Blog 1',
            image: recentImg,
            date: '2022-10-10',
            readTime: '5-Minute Read',
        },
        {
            id: 2,
            title: 'Recent Blog 2',
            image: recentImg,
            date: '2022-10-10',
            readTime: '5-Minute Read',
        },
        {
            id: 3,
            title: 'Recent Blog 3',
            image: recentImg,
            date: '2022-10-10',
            readTime: '5-Minute Read',
        },
        {
            id: 4,
            title: 'Recent Blog 4',
            image: recentImg,
            date: '2022-10-10',
            readTime: '5-Minute Read',
        },
        {
            id: 5,
            title: 'Recent Blog 5',
            image: recentImg,
            date: '2022-10-10',
            readTime: '5-Minute Read',
        }
    ]
    return (
        <>
            <Helmet>
                <title>Blog Details</title>
            </Helmet>
            <section className='breadcrumb__section bg-overlay padding__tb'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'> Impact of Foreign Policy on African FX Markets </h3>
                            </div>
                        </div>
                        <div className='col-12 col-lg-12 mt-5'>
                            <ul className='breadcrumb__list d-flex justify-content-center gap-5'>
                                <li className='breadcrumb__list__item'>
                                    <Link to='/' className='text-decoration-none breadcrumb__list__link'>Virtual Accounts</Link>
                                </li>
                                <li><Link to='' className='text-decoration-none'>Dec 27th, 2024</Link></li>
                                <li><Link to='' className='text-decoration-none'>5-Minute Read</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className='blog__details__section padding__tb'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-8'>
                            <div className='blog__details__content'>
                                <img src={Img1} alt="" className='img-fluid' />
                                <div className='blog__details__content__text'>
                                    <p>
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse incidunt, animi est labore facilis sunt quam explicabo voluptas quidem totam. Exercitationem fuga vel consequatur deserunt est dicta minima adipisci voluptatum.
                                    </p>
                                    <p>
                                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ab labore ut, aliquam voluptatum eligendi nesciunt hic quos? Dicta ipsam minus earum labore voluptatibus voluptas et, odio tenetur, voluptates, consequatur id!
                                    </p>
                                    <p>
                                        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Natus temporibus nemo odio saepe eveniet aspernatur quaerat maiores repellat ducimus libero. Ducimus odio exercitationem magnam asperiores nulla molestias quibusdam a sint.
                                    </p>
                                    <p>
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed, maiores at. In ab tempora sit doloribus vitae ipsum est possimus, neque error, totam dolorem nam ad sunt maiores libero ut?
                                    </p>
                                    <p>
                                        Nam tempor cursus lorem, in tempus purus. Duis dui sem, vestibulum viverra risus quis, hendrerit elementum diam. Duis sed erat dictum, pellentesque lacus in, porttitor nisi. Praesent tempor velit eu arcu tincidunt, at accumsan ante vestibulum. Aliquam feugiat erat ut hendrerit sollicitudin. Quisque tincidunt libero lacus, laoreet luctus lectus posuere sit amet. Duis tincidunt turpis eu sodales aliquet. Aliquam vehicula arcu quis ipsum euismod, eget aliquet sem rutrum. Pellentesque arcu ligula, ultricies vel eleifend sollicitudin, interdum vitae sapien. Curabitur eu volutpat nulla, vitae efficitur ex. Curabitur risus quam, interdum nec molestie a, auctor a turpis. Sed sit amet sem sed neque accumsan molestie in sit amet nisi.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='blog__details__sidebar'>
                                <div className='blog__details__sidebar__recent' style={{ paddingBottom: '100px' }}>
                                    <h3>Related Stories</h3>
                                    {recentblog.map((blog) => (
                                        <div className='blog__details__sidebar__recent__item'>
                                            <div className='blog__details__sidebar__recent__item__pic'>
                                                <img src={blog.image} className='recent__img' alt='' />
                                            </div>
                                            <div className='blog__details__sidebar__recent__item__body'>
                                                <h5>{blog.title}</h5>
                                                <p>{blog.date} | {blog.readTime}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='blog__details__sidebar__'>
                                    <div className="card bg-dark text-white">
                                        <div className="position-relative card__img__overlay_feature">
                                            <div className='card__img__overlay'></div>
                                            <img src={featureImg2} className="card-img  object-fit-cover" alt="News item" />
                                            <div className="card__img__overlay__feature__content">
                                                <h5 className="card-title">NEWS ITEM TITLE #1</h5>
                                                <p className="card-text">This text will describe what the news item is about...</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='blog__recent__section padding__tb'>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <h2 className="h3 mb-0">Most Recent Stories</h2>
                            {/* Custom navigation buttons */}
                            <div className='custom__navigation__buttons pt-4 ps-0 pe-0'>
                                <button className="btn btn-link text-primary me-2 ">
                                    <ArrowLeft size="32" className="swiper-button-prev-custom" />
                                </button>
                                <button className="btn btn-link text-primary ">
                                    <ArrowRight size="32" className="swiper-button-next-custom" />
                                </button>
                            </div>
                        </div>
                        <div className='col-12 col-md-8'>
                            <Swiper
                                modules={[Navigation, Pagination]}
                                spaceBetween={30}
                                slidesPerView={3}
                                navigation={{
                                    prevEl: '.swiper-button-prev-custom',
                                    nextEl: '.swiper-button-next-custom',
                                }}
                                pagination={{
                                    clickable: true,
                                    el: '.swiper-custom-pagination',
                                    bulletClass: 'btn btn-link p-1',
                                    bulletActiveClass: 'text-primary',
                                }}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 20
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 30
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                        spaceBetween: 30
                                    }
                                }}
                            >
                                {RecentStories.map((story) => (
                                    <SwiperSlide key={story.id}>
                                        <div className="blog__recent__card">
                                            <img
                                                src={story.image}
                                                className="blog__recent__card__img img-fluid"
                                                alt={story.title}

                                            />
                                            <div className="blog__recent__body px-0">
                                                <h5 className="blog__recent__title">{story.title}</h5>
                                            </div>
                                        </div>
                                        {/* Custom pagination */}
                                        <div className="swiper-custom-pagination"></div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>

            <CTAButton />
        </>
    )
}

export default BLogDetails